import { Container, Row, Col } from 'react-bootstrap';

const CommunityCenter = () => {
  return (
    <Container className="mt-4 ps-0 pe-0">
      <Row>
        <Col>
          <h4>AWM Community Center</h4>
          <p>
            As part of our ongoing commitment to enhancing community living,
            Aparna is delivering on the promise of building a dedicated
            Community Center/Hall for AWM residents.
          </p>
          <p>
            Construction work for this much-awaited facility began this year in
            Phase 2, Plot 327 and is currently in progress. Once completed, the
            Community Center will serve as a vibrant hub for social gatherings,
            cultural events, celebrations, and recreational activities—bringing
            neighbors together and strengthening the bonds that make AWM a great
            place to live.
          </p>
          <p>
            Stay tuned for updates as we move closer to creating this shared
            space for all residents to enjoy.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default CommunityCenter;
